import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const Star: React.FC<SVGProps<SVGSVGElement>> = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.15075 4.86578C9.54202 4.23647 10.4579 4.23647 10.8492 4.86578L12.1305 6.9266C12.2682 7.14802 12.4869 7.30691 12.74 7.36942L15.0959 7.9512C15.8153 8.12886 16.0984 8.99994 15.6208 9.56654L14.0568 11.422C13.8887 11.6213 13.8052 11.8784 13.824 12.1385L13.9987 14.5588C14.052 15.298 13.311 15.8363 12.6246 15.5572L10.3767 14.6431C10.1351 14.5449 9.86482 14.5449 9.62329 14.6431L7.37537 15.5572C6.68892 15.8363 5.94793 15.298 6.00128 14.5588L6.17599 12.1385C6.19476 11.8784 6.11122 11.6213 5.94318 11.422L4.37918 9.56654C3.90158 8.99995 4.18461 8.12886 4.90404 7.9512L7.25994 7.36942C7.51306 7.30691 7.73176 7.14802 7.86943 6.9266L9.15075 4.86578Z"
        fill="#35C08E"
      />
    </svg>
  )
}

Star.displayName = 'Star'

export default withIcon(Star)
